Application.Wordmark = {
    ready: function () {

        this.Position.ready();
        this.Loading.ready();

    }
}